module.exports = __webpack_public_path__ + "img/nullCart.494170a9.png";